import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyGinIssueCloneRoute: InvariantJiraRoute = {
	name: 'legacy-gin-issue-clone',
	path: '/(secure|issue)/CloneIssue(\\w*)([!%]?[\\w]*).jspa',
};
